module.exports = __webpack_public_path__ + "502fd510f96ea707584decb73c5421a7.MP3";